/**
 * Stable error-boundary fingerprints, copied from taxrise-clients
 * `apps/admin/lib/report-app-error.ts` (`fingerprint: admin-${scope}-error-boundary`,
 * `tags: { boundary: scope }`). Delete when `@miadvg/posthog` ships this helper.
 */
import { captureException } from "@miadvg/posthog";

export const BOUNDARY_FINGERPRINTS = {
  portal: "booking-portal-error-boundary",
  admin: "booking-admin-error-boundary",
  staff: "booking-staff-error-boundary",
  root: "booking-root-error-boundary",
  global: "booking-global-error-boundary",
} as const;

export type BoundaryScope = keyof typeof BOUNDARY_FINGERPRINTS;

export function reportBoundaryError(
  error: Error & { digest?: string },
  scope: BoundaryScope,
): void {
  try {
    captureException(error, {
      fingerprint: BOUNDARY_FINGERPRINTS[scope],
      tags: { boundary: scope },
      extra: { digest: error.digest },
    });
  } catch {
    // A tracking failure must not hide the recovery UI.
  }
}
